import React, { useState } from 'react';
import GoogleMapReact from "google-map-react";
import dhl_logo from '../../../src/assets/images/dhl_logo.jpg'
import yellow_icon from '../../../src/assets/images/yellow_map_icon.png'
import { Grid } from '@material-ui/core';
import InputButton from '../../framework/Inputs/inputButton/inputButton';
import ListItem from '@material-ui/core/ListItem';
import './customGoogleMap1.scss'
import List from '@material-ui/core/List';


const CustomGoogleMap = ({ data, onSelect,props }) => {
  const [selectedMarker, setSelectedMarker] = useState(null);
  const handleMarkerClick = (item) => {
    setSelectedMarker(item);
  };

  
console.log(props)
  const handleSelect = () => {
    onSelect(selectedMarker);
  };
  const Marker = ({ item, isSelected, onClick }) => (
    <div style={{ position: 'relative', cursor: 'pointer', zIndex: isSelected ? 999 : 1 }}>
      <img src={dhl_logo} alt="dhl_logo" width="35" height="35" style={{ transition: 'transform 0.3s', transform: isSelected ? 'translateY(-10px)' : 'none' }} onClick={onClick} />
    </div>
  );

  const AddressMarker = ({ item, isSelected, onClick }) => (
    <div style={{ position: 'relative', cursor: 'pointer', zIndex: isSelected ? 999 : 1 }}>
      <img src={yellow_icon} alt="dhl_logo" width="35" height="35" style={{ transition: 'transform 0.3s', transform: isSelected ? 'translateY(-10px)' : 'none' }} onClick={onClick} />
    </div>
  );

  return (
    <div style={{display:'flex' }}>
        <div className='map'>
      <div style={{ height: '350px' }}>
        <GoogleMapReact
          bootstrapURLKeys={{ key: "AIzaSyAYjOCT5csZSYkhA2Try8LFEmUdRetkpa8" }}
          defaultCenter={{
            lat: data.length > 0 ? data[0].latitude : 51.505,
            lng: data.length > 0 ? data[0].longitude : -0.09,
          }}
          defaultZoom={13}
          options={{
            gestureHandling: "greedy"
        }}>
          {data.map((item, index) => (
            <Marker
              key={index}
              lat={item.latitude}
              lng={item.longitude}
              onClick={() => handleMarkerClick(item)}
            />
          ))}
          {props?.longitude && props?.latitude &&
          <AddressMarker
          lat={props?.latitude}
          lng={props?.longitude}
        />
          }
        </GoogleMapReact>
      </div>
      </div>
      {selectedMarker && (
        <>
        <div className="DialogBoxContent">
          <div className="CustomGoogleMap">
            <List>
              <ListItem className="row" button >
                <table className="map-list-items">
                <tr>
                  <td className="map-item-two items">
                    <h2 id='distance_title'>Distance:</h2>
                    <div className='distance_data'>
                    <p>Distance {parseFloat((selectedMarker?.distance || 0) * (0.00062137)).toFixed(2)} miles</p>
                    </div>
                  </td>
                  </tr>
                  <tr>
                  <td className="map-item-one map-items">
                    <h2 id='address_title'>Address:</h2>
                    <div class='address_data'>
                    <p>{selectedMarker?.title}</p>
                    <p>{selectedMarker?.address?.address1}</p>
                    <p>{selectedMarker?.address?.address2}</p>
                    <p>{selectedMarker?.address?.address3}</p>
                    <p>{selectedMarker?.address?.postalTown}</p>
                    <p>{selectedMarker?.address?.zipcode}</p>
                    </div>
                  </td>
                  </tr>
                  <tr>
                  <td className="map-item-three items">
                    <h2 id='hours_title'>Opening Hours:</h2>
                    <div className='hours_data'>
                    {selectedMarker?.openingHours?.map((openingTime) => (
                      <p>
                        {openingTime?.dayDescription}-{openingTime?.timeDescription}{' '}
                      </p>
                    ))}
                    </div>
                  </td>
                  </tr>
                </table>
              </ListItem>
            </List>
          </div>
          <Grid item style={{ lineHeight: '20.4px', paddingBottom: '10px' }}>
            <InputButton
              id="selectService"
              variant="contained"
              className="contained-btn"
              onClick={handleSelect}
              label="Select Service Point"
            />
          </Grid>
          </div>
        </>
      )}

    </div>

  );
};
export default CustomGoogleMap;